<template>
  <div>
    <form class="form-horizontal">
      <h1 class="section-divider text-success">
        {{ $t('profileApproval.requestEdit') }}
      </h1>
      <div class="row" style="font-size: 12px">
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.lastNameKh')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('last_name_kh').edit
                }"
                >{{
                  checkKeyExist('last_name_kh').value
                    ? checkKeyExist('last_name_kh').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">{{
              $t('profileApproval.firstNameKh')
            }}</span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('first_name_kh').edit
                }"
                >{{
                  checkKeyExist('first_name_kh').value
                    ? checkKeyExist('first_name_kh').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.lastNameEn') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('last_name_en').edit }"
                >{{
                  checkKeyExist('last_name_en').value
                    ? checkKeyExist('last_name_en').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.firstNameEn') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('first_name_en').edit }"
                >{{
                  checkKeyExist('first_name_en').value
                    ? checkKeyExist('first_name_en').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.sex') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('gender').edit
                }"
                >{{
                  checkKeyExist('gender').value
                    ? checkKeyExist('gender').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.dateOfBirth') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('date_of_birth').edit
                }"
                >{{
                  checkKeyExist('date_of_birth').value
                    ? checkKeyExist('date_of_birth').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.placeOfBirth') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('place_of_birth').edit
                }"
                >{{
                  checkKeyExist('place_of_birth').value
                    ? checkKeyExist('place_of_birth').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.phoneNumber') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('phone').edit }"
                >{{
                  checkKeyExist('phone').value
                    ? checkKeyExist('phone').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.email') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('email').edit }"
                >{{
                  checkKeyExist('email').value
                    ? checkKeyExist('email').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.facebook') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('facebook_account').edit
                }"
                >{{
                  checkKeyExist('facebook_account').value
                    ? checkKeyExist('facebook_account').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.emergencyContactPerson') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('emergency_contact_person').edit
                }"
                >{{
                  checkKeyExist('emergency_contact_person').value
                    ? checkKeyExist('emergency_contact_person').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.emergencyContactRelation') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{
                  'text-success': checkKeyExist('emergency_contact_relation')
                    .edit
                }"
                >{{
                  checkKeyExist('emergency_contact_relation').value
                    ? checkKeyExist('emergency_contact_relation').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.province') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('province_code').edit }"
              >
                <select v-model="checkKeyExist('province_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(province, index) in provinces"
                    :value="province.province_code"
                    :key="index"
                  >
                    {{ province.province_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.district') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('district_code').edit }"
              >
                <select v-model="checkKeyExist('district_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(district, index) in districts"
                    :value="district.district_code"
                    :key="index"
                  >
                    {{ district.district_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.commune') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('commune_code').edit }"
              >
                <select v-model="checkKeyExist('commune_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(commune, index) in communes"
                    :value="commune.commune_code"
                    :key="index"
                  >
                    {{ commune.commune_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.village') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('village_code').edit }"
              >
                <select v-model="checkKeyExist('village_code').value">
                  <option :value="null">-</option>
                  <option
                    v-for="(village, index) in villages"
                    :value="village.village_code"
                    :key="index"
                  >
                    {{ village.village_name }}
                  </option>
                </select>
              </label>
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.streetNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('street_no').edit }"
                >{{
                  checkKeyExist('street_no').value
                    ? checkKeyExist('street_no').value
                    : '-'
                }}</label
              >
            </div>
          </div>
          <div class="row form-group">
            <span class="col-md-5 form-col-label control-label">
              {{ $t('profileApproval.houseNo') }}
            </span>
            <div class="col-md-7 ts-whitespace-no-wrap">
              <label
                class="col-md-5 form-col-label control-label text-left"
                :class="{ 'text-success': checkKeyExist('house_no').edit }"
                >{{
                  checkKeyExist('house_no').value
                    ? checkKeyExist('house_no').value
                    : '-'
                }}</label
              >
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row form-group">
            <div class="col-md-12 text-center">
              <div
                id="img-frame"
                :class="{
                  'background-blue': checkKeyExist('photo').edit
                }"
                class="text-center"
              >
                <img
                  v-lazy="{
                    src: photo(),
                    error: onError(),
                    loading: require('@/assets/Rolling-1s-200px_2.svg')
                  }"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 class="section-divider"></h1>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'motherRequestEdit',
  props: ['info', 'edit'],
  data() {
    return {
      data: {},
      errors: new Errors(),
      boyPhoto: require('../../../../../assets/student-default-boy.png'),
      girlPhoto: require('../../../../../assets/student-default-girl.png'),
      file: require('../../../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('parentProfile', ['provinces']),
    ...mapState('home/staffMyApproval', ['districts', 'communes', 'villages'])
  },
  methods: {
    photo() {
      if (this.checkKeyExist('photo').value) {
        return `/api/files?filePath=${this.checkKeyExist('photo').value}`
      }
      if (
        this.checkKeyExist('gender').value == 'Male' ||
        this.checkKeyExist('gender').value == 'M'
      ) {
        return this.boyPhoto
      }
      if (
        this.checkKeyExist('gender').value == 'Female' ||
        this.checkKeyExist('gender').value == 'F'
      ) {
        return this.girlPhoto
      }
    },
    onError() {
      event
        ? (event.target.src =
            this.checkKeyExist('gender').value == 'Male'
              ? this.boyPhoto
              : this.girlPhoto)
        : ''
    },
    checkKeyExist(key) {
      let result = this.edit.filter(e => e.column_name == key)
      if (result.length > 0) {
        return {
          edit: true,
          value: result[0].new_value
        }
      }
      return {
        edit: false,
        value: this.info[key]
      }
    }
  }
}
</script>
<style lang="css" scoped>
#cover-image img {
  object-fit: contain;
  width: 100%;
  height: 100%;
}
.section-divider {
  border-bottom: 1px solid #eee;
  margin-bottom: 10px;
}
.text-uppercase {
  text-transform: uppercase !important;
}
#img-frame {
  display: block;
  position: relative;
  margin-top: 5px;
}
#img-frame img {
  object-fit: contain;
  width: 45%;
  border-radius: 5px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 3px;
  margin: 0 auto;
}
.background-blue img {
  background: #00acac;
}
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
/* This is to remove the arrow of select element in IE */
select::-ms-expand {
  display: none;
}
select {
  -webkit-appearance: none;
  appearance: none;
}

option {
  text-align: left;
}
</style>
